import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../utils/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchUserData(email) {
    try {
      // 1️⃣ Check orders
      const docRef = query(
        collection(db, 'orders'),
        where('auth_email', '==', email)
      );

      const docSnap = await getDocs(docRef);

      if (docSnap.size !== 0) {
        const data = docSnap.docs[0].data();
        return data;
      }

      // 2️⃣ Check authenticated_users
      const applicationRef = query(
        collection(db, 'orders', 'authenticated_users', 'authenticated_users'),
        where('auth_email', '==', email)
      );

      const appSnap = await getDocs(applicationRef);

      if (appSnap.size !== 0) {
        return appSnap.docs[0].data();
      }

      // 3️⃣ Fallback to users + orders (your existing logic)
      const userRef = query(
        collection(db, 'users'),
        where('email', '==', email)
      );

      const userSnap = await getDocs(userRef);

      if (userSnap.size === 0) return null;

      const baseUser = userSnap.docs[0].data();

      const clientUserQuery = query(
        collection(db, 'orders'),
        where('name', '==', baseUser.name)
      );

      const clientUserSnap = await getDocs(clientUserQuery);

      if (clientUserSnap.size === 0) return null;

      const merged = {
        ...baseUser,
        ...clientUserSnap.docs[0].data()
      };

      return merged;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      const userData = await fetchUserData(firebaseUser.email);

      if (!userData) {
        setUser(null);
      } else {
        setUser({
          ...userData,
          role: userData.role?.startsWith('billing_')
            ? userData.role
            : `billing_${userData.role}`,
          email: firebaseUser.email
        });
      }

      setLoading(false);
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
